import base from './base';
import admin from './admin';
import legalAds from './legal-ads';
import myAccount from './my-account';

export default [].concat(admin, legalAds, myAccount, base);
